<div class="flex flex-col bg-surface-50 dark:bg-surface-950 min-h-full">
    <div class="flex flex-col gap-3 p-3">
        <div class="flex grid-cols-1  gap-3">
            <!-- Document Types Section -->
            <div class=" w-[30%] shadow rounded-base p-3 border flex flex-col gap-3">
                <div class="flex flex-col gap-2 h-full max-h-[calc(100vh-7rem)] overflow-hidden">
                    <div class="flex items-center justify-between">
                        <div class="text-surface-900 dark:text-surface-0 font-semibold text-lg">Document Types</div>
                    </div>

                    <div class="overflow-y-auto overflow-x-hidden flex-1 min-h-0">
                        @if(docTypeLoading){
                        @for (item of getSkeletonCount(); track $index) {
                        <div class="w-full h-20 pt-2">
                            <p-skeleton width="100%" height="90%" />
                        </div>
                        }
                        }
                        @else{
                        @for (keyPoint of documentTypes; track keyPoint._id) {
                        <div class="flex flex-row gap-2 border p-3 my-2 justify-between rounded-base items-center cursor-pointer max-w-full"
                            [class.active-key-point]="selectedDocType === keyPoint._id"
                            (click)="changeDocumentType(keyPoint._id)">
                            <div class="flex flex-row gap-2 flex-1 items-center overflow-hidden min-w-0">
                                <span
                                    class="border p-1.5 sm:p-2 rounded-base key-point-icon inline-flex items-center justify-center text-sm sm:text-base">
                                    <i class="pi pi-file"></i>
                                </span>
                                <div class="min-w-0">
                                    <div class="font-bold text-sm sm:text-base truncate" [pTooltip]="keyPoint.name">{{keyPoint.name}}</div>
                                    <div class="text-gray-500 truncate text-xs sm:text-sm"
                                        [pTooltip]="keyPoint.description">
                                        {{keyPoint.description}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        }
                    </div>
                </div>
            </div>

            <!-- Checklists Section -->
            <div class="w-[70%] flex flex-col gap-3">
                <div class="flex items-center justify-between gap-3">
                    <div class="text-surface-900 dark:text-surface-0 font-semibold text-lg lg:hidden">Checklists</div>
                    <div class="flex justify-end w-full gap-2">
                        <app-button variant="filled" severity="primary" label="Add" icon="pi pi-plus"
                            (clicked)="handleClickAddChecklist()" />
                    </div>
                </div>
                <div class="flex-1 overflow-y-auto scrollbar-thin max-h-[calc(100vh-13rem)]">
                    <div class="checklist-wrapper">
                        @if(loading){
                        <div class="skeleton-card">
                            <div class="border-round border-1 surface-border surface-card p-3 h-full">
                                <div class="flex flex-col gap-4 h-full">
                                    @for (item of getSkeletonCount(); track $index) {
                                    <div class="w-full h-20">
                                        <p-skeleton width="auto" height="100%" />
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                        }
                        @else {
                        @if(!checklists.length) {
                        <p class="text-center">No checklists found</p>
                        }
                        @else {
                        @for (checklist of checklists; track checklist._id; let i = $index) {
                        <p-accordion class="w-full border rounded-base">
                            <p-accordion-panel value="0">
                                <p-accordion-header>
                                    <div
                                        class="flex flex-col sm:flex-row justify-between w-full gap-2 items-start sm:items-center">
                                        <div class="flex flex-col w-full sm:w-auto">
                                            <input pInputText type="text" [value]="checklist.name"
                                                class="input w-full sm:w-60 rounded-base"
                                                (change)="update(checklist._id, FIELDS.name, $event)"
                                                (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">

                                            @if (this.emptyTitleWarnings[checklist._id!]) {
                                            <p class="text-danger text-xs sm:text-sm mt-2">Title cannot be empty, empty
                                                title
                                                won't be
                                                saved</p>
                                            }
                                        </div>
                                        <div class="flex flex-row items-center gap-2 pr-2">
                                            <i class="pi pi-copy cursor-pointer" pTooltip="Copy" tooltipPosition="top"
                                                (click)="copyChecklist(checklist._id); $event.stopPropagation()"></i>
                                            <i class="pi pi-trash cursor-pointer text-danger" pTooltip="Delete"
                                                tooltipPosition="top"
                                                (click)="deleteChecklist(checklist._id); $event.stopPropagation()"></i>
                                        </div>
                                    </div>
                                </p-accordion-header>
                                <p-accordion-content>
                                    <textarea pTextarea [value]="checklist.description" [autoResize]="true"
                                        placeholder="Definition" class="w-full rounded-base" rows="3"
                                        (change)="update(checklist._id, FIELDS.description, $event)">
                                    </textarea>
                                    <div class="my-1">
                                        @if(this.emptyDescriptionWarnings[checklist._id!] == true){
                                        <p class="text-danger text-sm font-semibold"> Description cannot be empty ,
                                            empty
                                            description wont be
                                            saved</p>
                                        }
                                    </div>
                                    <div class="flex flex-row gap-2">
                                        <div class="flex flex-wrap gap-1 mb-2">
                                            @if(chipLoading){
                                            <p-skeleton width="50%"></p-skeleton>
                                            }
                                            @else{
                                            @if(checklist._id && selectedTagsByChecklist[checklist._id] &&
                                            selectedTagsByChecklist[checklist._id].tagTypes) {
                                            @if(selectedTagsByChecklist[checklist._id].all){
                                            <p-chip class="rounded-base" [style]="{ backgroundColor: 'var(--orange-100)', color: '#000' }"
                                                [label]="'All'"></p-chip>
                                            }
                                            @else{
                                            @for (tagType of selectedTagsByChecklist[checklist._id].tagTypes | keyvalue;
                                            track
                                            tagType) {
                                            @if(tagType.value.all) {
                                            <p-chip class="rounded-base" [style]="{ backgroundColor: 'var(--orange-100)', color: '#000' }"
                                                [label]="tagTypesById[tagType.key].name + ': All'" [removable]="true"
                                                (onRemove)="removeChips(checklist._id, tagType.key)"></p-chip>
                                            }
                                            @else {
                                            @for (tag of tagType.value.values; track tag) {
                                            <p-chip class="rounded-base" [style]="{ backgroundColor: 'var(--orange-100)', color: '#000' }"
                                                [label]="tagTypesById[tagType.key].name + ': ' + tagsById[tag].name"
                                                [removable]="true"
                                                (onRemove)="removeChip(checklist._id, tagType.key, tag)"></p-chip>
                                            } } } } } }
                                        </div>
                                    </div>
                                    <div class="flex flex-row">
                                        <app-button (clicked)="onClickAddTag(checklist._id ?? '')" label="Add Tag"
                                            severity="contrast" icon="pi pi-plus" variant="outlined" />
                                    </div>
                                </p-accordion-content>
                            </p-accordion-panel>
                        </p-accordion>
                        }
                        }
                        }
                    </div>
                </div>
                <div class="flex-shrink-0">
                    @if(checklists.length > 0) {
                    <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
                        [totalRecords]="totalRecords" [rowsPerPageOptions]="[5, 10, 20]" />
                    }
                </div>
            </div>
        </div>
    </div>
</div>

@if(deleteChecklistDialogVisible){
    <app-delete-confirmation [(visible)]="deleteChecklistDialogVisible" headerText="Are you sure?"
        bodyText="This action will delete the checklist" confirmButtonText="Proceed" (onConfirm)="confirmDeleteChecklist()">
    </app-delete-confirmation>
}

<app-dialog [(visible)]="openAddTagDialog" title="Map tags" (closed)="saveTags()"
    class="max-w-[600px] h-[60vh]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col h-full p-4">
            @if(!tagTypes || tagTypes.length === 0) {
            <div class="flex flex-col gap-2 justify-center items-center">
                <p class="text-center">No Connected Tags found</p>
                <div class="flex pr-2 pb-2 justify-center item-center">
                    <app-button label="Add" variant="filled" severity="primary" icon="pi pi-plus"
                        (clicked)="addTagTypes()" />
                </div>
            </div>
            }
            @if(tagTypes && tagTypes.length > 0) {
            <div class="flex items-center gap-2">
                <app-checkbox [value]="selectedTagsByChecklist[selectedChecklist].all"
                    (onChange)="changesDone = true; onSelectAllChange($event)"
                    [config]="{ binary: true, label: 'Select All Tags' }"></app-checkbox>
            </div>
            }
            <p-tabs [value]="tagTypeIdx.toString()" (onTabChange)="onTabChange($event)" class="overflow-hidden h-full">
                <p-tablist>
                    @for(tagType of tagTypes; track $index; let i = $index) {
                    <p-tab [value]="i.toString()" class="flex items-center !gap-2">
                        <span class="font-bold whitespace-nowrap">{{tagType.name}}</span>
                    </p-tab>
                    }
                </p-tablist>
                <p-tabpanels>
                    @for(tagType of tagTypes; track $index; let i = $index) {
                    <p-tabpanel [value]="i.toString()" class="h-full">
                        @if (tagType._id) {
                        <div *ngIf="!isLoadingTags; else loadingTemplate">
                            @if((tagsByTagType[tagType._id] || []).length > 0) {
                            <p-listbox [options]="tagsByTagType[tagType._id] || []"
                                (ngModelChange)="changesDone = true; onTagChange($event, tagType._id)" optionValue="_id"
                                [ngModel]="selectedTagsByChecklist[selectedChecklist].tagTypes[tagType._id].values"
                                [multiple]="true"
                                [checkbox]="(tagsByTagType[tagType._id] || []).length > 0 ? true : false"
                                [filter]="(tagsByTagType[tagType._id] || []).length > 0 ? true : false"
                                [filterPlaceHolder]="'Search Tags...'" optionLabel="name" class="h-full">
                            </p-listbox>
                            }
                            @else {
                            <p class="text-center">No Tags found</p>
                            }
                        </div>
                        <ng-template #loadingTemplate>
                            <div>Loading Tags...</div>
                        </ng-template>
                        }
                    </p-tabpanel>
                    }
                </p-tabpanels>
            </p-tabs>
        </div>
    </ng-template>
</app-dialog>


<app-dialog [(visible)]="addChecklistVisible" title="Add a Checklist"
    (closed)="addChecklistVisible = false" class="max-w-[40vw]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <form [formGroup]="checklistForm" class="p-4">
            <div class="flex flex-col gap-1 mb-3">
                <label for="name" class="text-sm sm:text-base">
                    Name<span class="text-danger">*</span>
                </label>
                <input id="name" type="text" pInputText formControlName="name" />
                <div *ngIf="checklistFormControls['name'].invalid && (checklistFormControls['name'].dirty || checklistFormControls['name'].touched)"
                    class="text-danger text-xs">
                    {{"Name is required." | titlecase}}
                </div>
            </div>
            <div class="flex flex-col gap-1 mb-3">
                <label for="definition" class="text-sm sm:text-base">
                    Definition<span class="text-danger">*</span>
                </label>
                <textarea pTextarea id="definition" formControlName="definition"></textarea>
                <div *ngIf="checklistFormControls['definition'].invalid && (checklistFormControls['definition'].dirty || checklistFormControls['definition'].touched)"
                    class="text-danger text-xs">
                    {{"Definition is required." | titlecase}}
                </div>
            </div>
        </form>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex flex-col sm:flex-row justify-end gap-2">
            <app-button variant="outlined" label="Cancel" icon="pi pi-times" (clicked)="addChecklistVisible=false"
                class="w-full sm:w-auto" />
            <app-button variant="filled" severity="primary" label="Add" icon="pi pi-plus" (clicked)="addNewChecklist()"
                [loading]="addChecklistLoader" class="w-full sm:w-auto" />
        </div>
    </ng-template>
</app-dialog>
